import { t } from "@redotech/redo-i18n";
import {
  BLUE_YONDER_PROVIDER,
  type DropoffProviderType,
  RETURN_BEAR_PROVIDER,
  VIRTUAL_PROVIDER,
} from "@redotech/redo-model/dropoff/dropoff-provider";
import { COMMON } from "@redotech/redo-model/localization/language";
import { Resource } from "@redotech/redo-model/localization/resource";
import { assertNever } from "@redotech/util/type";

export interface DropoffProviderCopy {
  title: string;
  subtitle: string;
  privacyPolicyText?: string;
}

/**
 * Localized modal copy for a dropoff provider, or `undefined` when no
 * per-provider override exists yet. Falls back to `COMMON` defaults when the
 * merchant's locale doesn't have a customized resource.
 */
export function getDropoffProviderCopy(
  provider: DropoffProviderType,
  copyResource: Resource | undefined,
): DropoffProviderCopy | undefined {
  switch (provider) {
    case BLUE_YONDER_PROVIDER:
      return {
        title:
          copyResource?.ShipmentMethodName_BLUE_YONDER_TITLE ||
          COMMON.ShipmentMethodName_BLUE_YONDER_TITLE,
        subtitle:
          copyResource?.ShipmentMethodName_BLUE_YONDER_SUBTEXT ||
          COMMON.ShipmentMethodName_BLUE_YONDER_SUBTEXT,
        privacyPolicyText: t(
          "By selecting you are agreeing to our privacy policy.",
        ),
      };
    case VIRTUAL_PROVIDER:
    case RETURN_BEAR_PROVIDER:
      return undefined;
    default:
      assertNever(provider);
  }
}
